const API_BASE = process.env.REACT_APP_API_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || '';

class ApiService {
  constructor() {
    this.sessionToken = null;
  }

  setSessionToken(token) {
    this.sessionToken = token;
  }

  async request(endpoint, options = {}) {
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    };

    // Add API key header
    if (API_KEY) {
      headers['x-api-key'] = API_KEY;
    }

    // Add session token to Authorization header
    if (this.sessionToken) {
      headers['Authorization'] = `Bearer ${this.sessionToken}`;
    }

    const response = await fetch(`${API_BASE}${endpoint}`, {
      ...options,
      headers
    });

    // Handle session expiry
    if (response.status === 401) {
      const error = await response.json().catch(() => ({}));
      if (error.expired) {
        // Clear session and reload to re-authenticate
        sessionStorage.removeItem('iptv_session');
        window.location.reload();
        return;
      }
      throw new Error(error.error || 'Unauthorized');
    }

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Request failed' }));
      throw new Error(error.error || error.message || `HTTP ${response.status}`);
    }

    return response.json();
  }

  // Playlists
  async getPlaylists() {
    return this.request('/api/playlists');
  }

  async getPlaylist(id) {
    return this.request(`/api/playlists/${id}`);
  }

  async addPlaylist(data) {
    return this.request('/api/playlists', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async updatePlaylist(id, data) {
    return this.request(`/api/playlists/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async deletePlaylist(id) {
    return this.request(`/api/playlists/${id}`, {
      method: 'DELETE'
    });
  }

  // PIN Management
  async verifyPin(id, pin) {
    return this.request(`/api/playlists/${id}/verify-pin`, {
      method: 'POST',
      body: JSON.stringify({ pin })
    });
  }

  async setPin(id, pin, currentPin = null) {
    const body = { pin };
    if (currentPin) body.currentPin = currentPin;

    return this.request(`/api/playlists/${id}/pin`, {
      method: 'PUT',
      body: JSON.stringify(body)
    });
  }

  async removePin(id, currentPin) {
    return this.request(`/api/playlists/${id}/pin`, {
      method: 'PUT',
      body: JSON.stringify({ pin: null, currentPin })
    });
  }
}

export const api = new ApiService();
